import * as React from "react";
import { Context } from "./_context";
export const CheckOutlineIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.873 2.873a7.252 7.252 0 1 1 10.253 10.256A7.252 7.252 0 0 1 2.873 2.873Zm9.192 1.061a5.75 5.75 0 1 0-8.13 8.131 5.75 5.75 0 0 0 8.13-8.13ZM11.56 6l-4 4.5a.752.752 0 0 1-1.146-.03l-2-2.5 1.172-.937L7.03 8.837l3.409-3.834 1.121.996Z", fill: "currentColor" }));
  return iconset[size];
};
CheckOutlineIcon.iconId = "JHkvDy";
